import { render, staticRenderFns } from "./ShoesPage.vue?vue&type=template&id=67431692&scoped=true"
import script from "./ShoesPage.vue?vue&type=script&lang=js"
export * from "./ShoesPage.vue?vue&type=script&lang=js"
import style0 from "./ShoesPage.vue?vue&type=style&index=0&id=67431692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67431692",
  null
  
)

export default component.exports